var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99983 6.66659C9.89016 6.66596 9.78144 6.687 9.67991 6.72845C9.57838 6.7699 9.48603 6.83104 9.40816 6.90826L4.40816 11.9083C4.25124 12.0652 4.16309 12.278 4.16309 12.4999C4.16309 12.7218 4.25124 12.9347 4.40816 13.0916C4.56508 13.2485 4.77791 13.3367 4.99983 13.3367C5.22175 13.3367 5.43458 13.2485 5.5915 13.0916L9.99983 8.67492L14.4082 13.0833C14.5676 13.2198 14.7726 13.2911 14.9824 13.283C15.1921 13.2749 15.3911 13.188 15.5395 13.0396C15.6879 12.8911 15.7748 12.6922 15.7829 12.4825C15.791 12.2727 15.7197 12.0677 15.5832 11.9083L10.5832 6.90826C10.4279 6.75428 10.2184 6.66748 9.99983 6.66659Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.725015b573e3edf3ea1bc8867cbe05f6.svg";
export { ForwardRef as ReactComponent };